import axios from "axios";
import config from "../../config/config";
import Cookie from "cookies-js";


export const Uteleme_service = {
    getUtelemeStats
};

function getUtelemeStats(data){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "api/getUtelemeStats/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}